

























































import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import HsaBankLegalFooter from "@/employee/components/shared/HsaBankLegalFooter.vue";
import HsaBankInvestmentsFooter from "@/employee/components/shared/HsaBankInvestmentsFooter.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";
import { usePartnerContentStore } from "@/shared/store/partnerContent";
import { startEmployeeCobrowse } from "@/employee/Utilities/glance";

@Component({
  components: {
    HsaBankLegalFooter,
    HsaBankInvestmentsFooter,
  },
})
export default class HsaBankFooterRoot extends Vue {
  portalCustomizationStore = usePortalCustomizationStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();
  partnerContentStore = usePartnerContentStore();
  featureFlagStore = useFeatureFlagStore();

  postloginfooterContent = "";

  created () {
    this.partnerContentStore.getPartnerPostLoginFooterContent();
    this.onPostLoginFooterContentLoaded();
  }

  mounted (): void {
    this.custodianSettingsStore.getCustodianSettings();
  }

  get isLoadingPostLoginFooterContent () {
    return this.partnerContentStore.isLoadingPartnerPostLoginFooterContent;
  }

  @Watch("isLoadingPostLoginFooterContent")
  onPostLoginFooterContentLoaded () {
    if (this.partnerContentStore.isLoadedPartnerPostLoginFooterContent) {
      this.postloginfooterContent = this.partnerContentStore.partnerPostLoginFooterContent;
    }
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get supportPhoneFormatted (): string {
    return `tel:+1-${this.portalCustomizationStore.supportInfo.supportPhone}`;
  }

  get aboutUsUrl (): string {
    return this.portalCustomizationStore.supportInfo.website;
  }

  get supportEmail (): string {
    return `mailto:${this.portalCustomizationStore.supportInfo.supportEmail}`;
  }

  get supportName (): string {
    return `${this.portalCustomizationStore.supportInfo.displayName} Customer Support`;
  }
  get hasPartnerSupportEmail (): boolean {
    return this.portalCustomizationStore.hasPartnerSupportEmail;
  }

  get glanceEnabledByFeatureFlag (): boolean {
    return this.featureFlagStore.flags.hsa9101AddGlanceCobrowse;
  }

  get glanceEnabledByPartner (): boolean {
    return this.userStore.consumerInitiateCobrowseEnabled;
  }

  get isGlanceHashKeyAvailable (): boolean {
    return !!this.userStore.currentBendUser?.glanceHashKey;
  }

  get showCobrowseLink () {
    return this.glanceEnabledByFeatureFlag && this.glanceEnabledByPartner;
  }

  onClickCobrowseLink () {
    startEmployeeCobrowse();
  }
}
